module.exports = __webpack_public_path__ + "static/john_cunningham-4179d0f15704c9053569a5a347e3024b.jpg";